import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tabla-scroll"
}
const _hoisted_2 = { class: "tabla-rubrica" }
const _hoisted_3 = { class: "celda-grado" }
const _hoisted_4 = { class: "celda-grado" }
const _hoisted_5 = { class: "celda-centro" }
const _hoisted_6 = { class: "celda-escala" }
const _hoisted_7 = { class: "celda-escala" }
const _hoisted_8 = { class: "celda-juicio" }
const _hoisted_9 = {
  key: 1,
  class: "vacio"
}

import { computed } from 'vue'
import type { RubricaCriterio, RubricaOpinion, GradoValoracionOpinion } from '@/interfaces/CriterioEvaluacion'
import { esRubricaOpinion } from '@/interfaces/CriterioEvaluacion'


export default /*@__PURE__*/_defineComponent({
  __name: 'RubricaTablaOpinion',
  props: {
    rubrica: {}
  },
  setup(__props: any) {

/**
 * Editor de la rúbrica de opinión.
 *
 * Las opciones que ofrece una pregunta salen de esta tabla: una etiqueta fuera de
 * ella no puntúa en la conversión a nota.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const grados = computed<GradoValoracionOpinion[]>(() => {
  const r = props.rubrica
  if (!r || !esRubricaOpinion(r)) return []
  return (r as RubricaOpinion).grados ?? []
})

function formatoRango(min?: number, max?: number): string {
  if (min == null || max == null) return '—'
  return `${formatoNumero(min)} a ${formatoNumero(max)}`
}

function formatoPct(min?: number | null, max?: number | null): string {
  if (min == null || max == null) return '—'
  return `${min} a ${max}`
}

function formatoNumero(v: number): string {
  return Number.isInteger(v) ? v.toFixed(1) : String(v)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (grados.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "GRADO DE VALORACIÓN"),
                _createElementVNode("th", null, "GRADO DE CUMPLIMIENTO"),
                _createElementVNode("th", null, "VALORACIÓN"),
                _createElementVNode("th", { class: "col-escala" }, "ESCALA CUANTITATIVA"),
                _createElementVNode("th", { class: "col-escala" }, "CUMPLIMIENTO %"),
                _createElementVNode("th", null, "JUICIO DE VALOR")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grados.value, (g, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", _hoisted_3, _toDisplayString(g.grado_valoracion || '—'), 1),
                  _createElementVNode("td", _hoisted_4, _toDisplayString(g.grado), 1),
                  _createElementVNode("td", _hoisted_5, _toDisplayString(g.valoracion || '—'), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString(formatoRango(g.rango_min, g.rango_max)), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(formatoPct(g.pct_min, g.pct_max)), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(g.juicio_de_valor || '—'), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_9, "Esta rúbrica no tiene tabla de valoración."))
  ]))
}
}

})